export default {
    intro: 'เติมช่องว่างให้ตารางสมบูรณ์ดูสิ!',
};
